import React, { useState, useEffect } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Button,
} from "reactstrap";
import useGlobal from "store";


// core components
import bgImage from "assets/img/bg-city.jpg";
import nowLogo from "assets/brand/logonew.png";
import { Redirect, Link } from "react-router-dom";

const RegisterPage = (props) => {

  const [redirectRoute, setRedirectRoute] = useState(false);

    const [state, actions] = useGlobal(
      state => state,
      actions => actions
    );

    useEffect(() => {
      console.log('state auth', state.auth);
      if(state.auth) {
        actions.userActions.getUserMe();
        setRedirectRoute('/admin/dashboard');
      }
    }, [state.auth, actions.userActions]);


    const [formState, setFormState] = useState({
      name: '',
      email: '',
      password: ''
    });

    const handleInputChange = (event) => {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      let formFields = { ...formState };
      formFields[name] = value;
      setFormState(formFields);
  }

    const submitForm = async (event) => {
      console.log('submit form');
      event.preventDefault();
      const justFormData = new FormData(event.target);
      var object = {};
      justFormData.forEach((value, key) => {object[key] = value});
      const formData = { ...formState };
      console.log('FORM DATA', formData);

      actions.userActions.createUser(formData);
    }
  
  
    return (redirectRoute ?  <Redirect to={redirectRoute} /> 
      : <>
        <div className="content">
          <div className="register-page">
            <Container>
              <Row className="justify-content-center">
                <Col lg={5} md={8} xs={12}>
                  <div className="info-area info-horizontal mt-5">
                    <div className="icon icon-primary">
                      <i className="now-ui-icons media-2_sound-wave" />
                    </div>
                    <div className="description">
                      <h5 className="info-title">No more pay-walls.</h5>
                      <p className="description">
                        Read the content you want without needing to subscribe.
                      </p>
                    </div>
                  </div>
                  <div className="info-area info-horizontal">
                    <div className="icon icon-primary">
                      <i className="now-ui-icons media-1_button-pause" />
                    </div>
                    <div className="description">
                      <h5 className="info-title">Read as much as you like.</h5>
                      <p className="description">
                      Pay monthly only for what you consume.
                      </p>
                    </div>
                  </div>
                  <div className="info-area info-horizontal">
                    <div className="icon icon-info">
                      <i className="now-ui-icons users_single-02" />
                    </div>
                    <div className="description">
                      <h5 className="info-title">You're in charge.</h5>
                      <p className="description">
                        Total transparency over pricing. Set controls on your spending.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={4} md={8} xs={12}>
                  <Card className="card-signup">
                    <CardHeader className="text-center">
                      <div className="logo-container">
                        <img src={nowLogo} style={ {maxWidth: '150px'} } alt="now-logo" />
                      </div>
                      <CardTitle tag="h4">Sign Up</CardTitle>
                      
                    </CardHeader>
                    <CardBody>
                      <Form onSubmit={submitForm}>
                        <InputGroup
                          
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="now-ui-icons users_circle-08" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            placeholder="Name..."
                            value={formState.name || ''} onChange={handleInputChange} name="name" id="name"
                          />
                        </InputGroup>
                        <InputGroup
                          
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="now-ui-icons ui-1_email-85" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="email"
                            placeholder="Email..."
                            value={formState.email || ''} onChange={handleInputChange} name="email" id="email"
                          />
                        </InputGroup>
                        <InputGroup
                          
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="now-ui-icons objects_key-25" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="password"
                            placeholder="Password..."
                            value={formState.password || ''} onChange={handleInputChange} name="password" id="password"
                          />
                        </InputGroup>
                        <div className="text-center">
                          <Button
                            color="primary"
                            size="lg"
                            className="btn-round mt-1"
                            type="submit"
                          >
                            Get Started
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                    <CardFooter className="text-center">
                      
                      <div className="text-center mt-2">
                        <p>
                          <Link to="/auth/login" className="link footer-link">
                            Already have an account?
                          </Link>
                        </p>
                      </div>
                    </CardFooter>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + bgImage + ")" }}
        />
      </>
    );
}

export default RegisterPage;
